import React from "react";
import { useAppSelector } from "../app/hooks";
import CreateCity from "./city/CreateCity";
import CreateState from "./state/CreateState";
import CreateCountry from "./country/CreateCountry";
import CreateRights from "./rights/CreateRights";
import CreateMenu from "./menu/CreateMenu";
import AppDrawer from "../components/drawer/Drawer";
import CreateRegion from "./region/CreateRegion";
import CreateAirlineClass from "./airlineclass/CreateAirlineClass";
import CreateAirport from "./airport/CreateAirport";
import CreateCurrency from "./currency/CreateCurrency";
import CreateFlightPlace from "./flightplace/CreateFlightPlace";
import CreateFoodOption from "./foodoption/CreateFoodOption";
import CreateGst from "./gst/CreateGst";
import CreateHotelMapping from "./hotelmapping/CreateHotelMapping";
import CreateMealType from "./mealtype/CreateMealType";
import CreateNationality from "./nationality/CreateNationality";
import CreatePaxType from "./paxtype/CreatePaxType";
import CreateRoomCategory from "./roomcategory/CreateRoomCategory";
import CreateRoomType from "./roomtype/CreateRoomType";
import CreateRoute from "./route/CreateRoute";
import CreateTermsAndCondition from "./termsandcondition/CreateTermsAndCondition";
import CreateVehicleSharingPax from "./vehiclesharingpax/CreateVehicleSharingPax";
import CreateVendorType from "./vendortype/CreateVendorType";
import CreateVehicleType from "./vehicletype/CreateVehicleType";
import CreateFestivals from "./festival/CreateFestivals";
import CreateCancellationPolicy from "./companypolicy/CreateCancellationPolicy";
import CreateLeadSource from "./leadsource/CreateLeadSource";
import CreateLeadStage from "./leadstage/CreateLeadStage";
import CreateLead from "./lead/CreateLead";
import CreateItineraryFacility from "./ItineraryFacility/CreateItineraryFacility";
import CreateContact from "./contact/CreateContact";
import CreateTestimonial from "./testimonial/CreateTestimonial";
import CreateSetting from "./setting/CreateSetting";
import RenewSubscriptionForm from "./organization/RenewSubscriptionForm";
import CreateTemplate from "./template/CreateTemplate";
import CreateVisaCategory from "./visacategory/CreateVisaCategory";
import CreateDocument from "./document/CreateDocument";
import CreateVisaCountry from "./visacountry/CreateVisaCountry";
import CreateTravelPurpose from "./travelpurpose/CreateTravelPurpose";
import CreateVisaProcessingOption from "./visaprocessingoption/CreateVisaProcessingOpttion";
import CreateAdditionalService from "./additionalservice/CreateAdditionalService";
import CreateEmploymentStatus from "./employmentstatus/CreateEmploymentStatus";
import CreateSponsorshipType from "./sponsorshiptype/CreateSponsorshipType";
import CreateTourService from "./tourservice/CreateTourService";
import CreateVisaGateway from "./visagateway/CreateVisaGateway";
import CreateEntryType from "./visaentrytype/CreateVisaEntryType";
import CreateClientLogo from "./clientlogo/CreateClientLogo";
import CreateInstagramStory from "./instagramstory/CreateInstagramStory";
import CreateActivity from "./activity/CreateActivity";
import CreateB2BService from "./b2bservice/CreateB2BService";
import CrateCouponCode from "./couponcode/CreateCouponCode";
import CreateSection from "./section/CreateSection";
import CreateDesignation from "./designation/CreateDesignation";
import CreateLostReason from "./lostreason/CreateLostReason";
import CreatePopup from "./popup/CreatePopup";
import CreateB2BDocument from "./b2bdocument/CreateB2BDocument";
import CreateBlogFAQ from "./blog/CreateBlogFAQ";
import CreateAmenities from "./amenities/CreateAmenities";

const Drawers = () => {
  const isDrawerOpen = useAppSelector((state) => state.drawer.open);
  const drawerName = useAppSelector((state) => state.drawer.name);

  //   ***********Note : Here you need to add key as a drawerName same which you passed from create Button***********

  const drawerComponents: Record<string, React.JSX.Element> = {
    cityForm: <CreateCity />,
    countryForm: <CreateCountry />,
    visacategoryForm: <CreateVisaCategory />,
    renewForm: <RenewSubscriptionForm />,
    stateForm: <CreateState />,
    rightsForm: <CreateRights />,
    menuForm: <CreateMenu />,
    regionForm: <CreateRegion />,
    tourserviceForm: <CreateTourService />,
    visagatewayForm: <CreateVisaGateway />,
    // sectorForm: <CreateSector />,
    airlineclassForm: <CreateAirlineClass />,
    airportForm: <CreateAirport />,
    currencyForm: <CreateCurrency />,
    flightplaceForm: <CreateFlightPlace />,
    foodoptionForm: <CreateFoodOption />,
    gstForm: <CreateGst />,
    hotelMappingForm: <CreateHotelMapping />,
    mealtypeForm: <CreateMealType />,
    nationalityform: <CreateNationality />,
    paxTypeForm: <CreatePaxType />,
    roomCategoryForm: <CreateRoomCategory />,
    entrytypeForm: <CreateEntryType />,
    roomTypeForm: <CreateRoomType />,
    routeForm: <CreateRoute />,
    termsAndConditionForm: <CreateTermsAndCondition />,
    vehicleSharingPaxForm: <CreateVehicleSharingPax />,
    vendorTypeForm: <CreateVendorType />,
    vehicletypeForm: <CreateVehicleType />,
    travelpurposeForm: <CreateTravelPurpose />,
    visaprocessingoptionForm: <CreateVisaProcessingOption />,
    additionalserviceForm: <CreateAdditionalService />,
    employmentstatusForm: <CreateEmploymentStatus />,
    sponsorshiptypeForm: <CreateSponsorshipType />,
    festivalsForm: <CreateFestivals />,
    cancellationpolicyForm: <CreateCancellationPolicy />,
    leadsourceForm: <CreateLeadSource />,
    leadStageForm: <CreateLeadStage />,
    leadForm: <CreateLead />,
    contactForm: <CreateContact />,
    itineraryFacilityForm: <CreateItineraryFacility />,
    testimonialForm: <CreateTestimonial />,
    settingForm: <CreateSetting />,
    templateForm: <CreateTemplate />,
    documentForm: <CreateDocument />,
    visacountryForm: <CreateVisaCountry />,
    clientLogoForm: <CreateClientLogo />,
    instagramStoryForm: <CreateInstagramStory />,
    activityForm: <CreateActivity />,
    b2bserviceForm: <CreateB2BService />,
    couponcodeForm: <CrateCouponCode />,
    sectionForm: <CreateSection />,
    designationForm: <CreateDesignation />,
    lostReasonForm: <CreateLostReason />,
    popUpForm: <CreatePopup />,
    b2bDocumentForm: <CreateB2BDocument />,
    blogFaqForm: <CreateBlogFAQ />,
    amenitiesForm: <CreateAmenities />,
  };

  return (
    <>
      {isDrawerOpen && Object.keys(drawerComponents).includes(drawerName) && (
        <AppDrawer>{drawerComponents[drawerName]}</AppDrawer>
      )}
    </>
  );
};

export default Drawers;
